import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';

class Filter extends Component {
  constructor(props) {
    super(props);
    //console.log("filter props", props)
    this.state = {
      servicios : [
        { servicio: 'atWeb' , id:0, color:"#525252"},
        { servicio: 'atMobile', id:1, color:"#525252"},
        { servicio: 'atIvr', id:2, color:"#525252"},
        { servicio: 'atMeta', id:3, color:"#525252"}],
    }
    
  }

  changeFilter = (event, value) => {

    this.props.InfoAutoComplete(value)
  };
  render(){
    const {servicios } =this.state
    const { classes } = this.props;
      
      return (
        <div className={classes.root}>
          
          <Autocomplete
          
          multiple
          id={option => option.id}
          options={servicios}
          getOptionLabel={option => option.servicio}
          onChange={this.changeFilter}
          renderOption={params => {
            return (
                <div style={{color:params.color}}>{params.servicio}</div>
            );
        }}
          renderInput={params => (
            <TextField
              //style={{color:params.color}}
              {...params}
              variant="standard"
              label="Filtro De Servicios"
              placeholder="Servicios"
              fullWidth
            />
          )}
          /*renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                style={{color:option.color}}
                variant="outlined"
                key={option.id}
                label={option.servicio}
                onDelete={() => option.id}
              />
            ))
          }*/
        />
          
        </div>
      );
    //}
    
  }
  
}


export default compose(withRouter, withStyles(styles))(Filter);